import {
  type EspecieListItem,
  type EspecieRequest,
  type EspecieResponse,
  type PresentacionListItem,
  type PresentacionRequest,
  type PresentacionResponse,
  type CalibreListItem,
  type CalibreRequest,
  type CalibreResponse
} from '../types/especie';
import { http } from '../../../../api/http';

export class EspecieService {
  private static readonly ENDPOINTS = {
    ESPECIES: '/Especie/especies',
    PRESENTACIONES: '/Especie/presentaciones',
    CALIBRES: '/Especie/calibres',
  };

  // Especies endpoints
  static async getEspecies(): Promise<EspecieListItem[]> {
    try {
      const response = await http.get(this.ENDPOINTS.ESPECIES);
      return response.data;
    } catch (error) {
      console.error('Error fetching especies:', error);
      throw error;
    }
  }

  static async getEspecieById(idEspecie: number): Promise<EspecieResponse> {
    try {
      const response = await http.get(`${this.ENDPOINTS.ESPECIES}/${idEspecie}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching especie by id:', error);
      throw error;
    }
  }

  static async saveEspecie(especie: EspecieRequest): Promise<EspecieResponse> {
    try {
      const isUpdate = !!especie.idEspecie;

      console.log(`${isUpdate ? 'Updating' : 'Creating'} especie:`, {
        url: this.ENDPOINTS.ESPECIES,
        method: 'POST',
        isUpdate,
        data: especie
      });

      const response = await http.post(this.ENDPOINTS.ESPECIES, especie);

      console.log(`Especie ${isUpdate ? 'updated' : 'created'} successfully:`, response.data);
      return response.data;
    } catch (error) {
      console.error(`Error ${especie.idEspecie ? 'updating' : 'creating'} especie:`, error);
      throw error;
    }
  }

  // Presentaciones endpoints
  static async getPresentaciones(): Promise<PresentacionListItem[]> {
    try {
      const response = await http.get(this.ENDPOINTS.PRESENTACIONES);
      return response.data;
    } catch (error) {
      console.error('Error fetching presentaciones:', error);
      throw error;
    }
  }

  static async getPresentacionesByEspecie(idEspecie: number): Promise<PresentacionListItem[]> {
    try {
      const response = await http.get(`${this.ENDPOINTS.PRESENTACIONES}/especie/${idEspecie}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching presentaciones by especie:', error);
      throw error;
    }
  }

  static async getPresentacionById(idPresentacion: number): Promise<PresentacionResponse> {
    try {
      const response = await http.get(`${this.ENDPOINTS.PRESENTACIONES}/${idPresentacion}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching presentacion by id:', error);
      throw error;
    }
  }

  static async savePresentacion(presentacion: PresentacionRequest): Promise<PresentacionResponse> {
    try {
      const isUpdate = !!presentacion.idPresentacion;

      console.log(`${isUpdate ? 'Updating' : 'Creating'} presentacion:`, {
        url: this.ENDPOINTS.PRESENTACIONES,
        method: 'POST',
        isUpdate,
        data: presentacion
      });

      const response = await http.post(this.ENDPOINTS.PRESENTACIONES, presentacion);

      console.log(`Presentacion ${isUpdate ? 'updated' : 'created'} successfully:`, response.data);
      return response.data;
    } catch (error) {
      console.error(`Error ${presentacion.idPresentacion ? 'updating' : 'creating'} presentacion:`, error);
      throw error;
    }
  }

  // Calibres endpoints
  static async getCalibres(): Promise<CalibreListItem[]> {
    try {
      const response = await http.get(this.ENDPOINTS.CALIBRES);
      return response.data;
    } catch (error) {
      console.error('Error fetching calibres:', error);
      throw error;
    }
  }

  static async getCalibresByPresentacion(idPresentacion: number): Promise<CalibreListItem[]> {
    try {
      const response = await http.get(`${this.ENDPOINTS.CALIBRES}/presentacion/${idPresentacion}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching calibres by presentacion:', error);
      throw error;
    }
  }

  static async getCalibreById(idCalibre: number): Promise<CalibreResponse> {
    try {
      const response = await http.get(`${this.ENDPOINTS.CALIBRES}/${idCalibre}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching calibre by id:', error);
      throw error;
    }
  }

  static async saveCalibre(calibre: CalibreRequest): Promise<CalibreResponse> {
    try {
      const isUpdate = !!calibre.idCalibre;

      console.log(`${isUpdate ? 'Updating' : 'Creating'} calibre:`, {
        url: this.ENDPOINTS.CALIBRES,
        method: 'POST',
        isUpdate,
        data: calibre
      });

      const response = await http.post(this.ENDPOINTS.CALIBRES, calibre);

      console.log(`Calibre ${isUpdate ? 'updated' : 'created'} successfully:`, response.data);
      return response.data;
    } catch (error) {
      console.error(`Error ${calibre.idCalibre ? 'updating' : 'creating'} calibre:`, error);
      throw error;
    }
  }
}